
import _ from 'underscore';
import React, { useCallback, useEffect, useMemo } from 'react';
import {
  UAPPlacementTypeAlias as EPT,
  useImageExperienceAdPreviewModel,
  UnstyledAdPreviewCarouselLayout as AdPreviewCarouselLayout,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';
import { IImageExperienceImage } from '@bingads-webui-campaign-react/responsive-ad-editor-utils';

import { IRecommendAd } from './types';

const adPreviewConfig = [{
  placementSetName: 'RecommandAd',
  placementTypes: [EPT.MSAN.MSEdgeSingleCarousel],
}];

const adPreviewConfigMMAV2 = [{
  placementSetName: 'RecommandAD-MMAV2',
  placementTypes: [EPT.MSANV2.MSNCarousel],
}];

interface IRecommendAdPreviewCarouselProps {
  isMMAV2Enabled: boolean;
  imageList: IImageExperienceImage[];
  ads: IRecommendAd[];
  url: string;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  i18n: any;
}

export const RecommandAdPreviewCarousel = ({
  isMMAV2Enabled,
  imageList,
  ads,
  url,
  activeIndex,
  setActiveIndex,
  i18n,
}: IRecommendAdPreviewCarouselProps) => {
  const {
    onUpdateImageExperienceImageList,
    multiImagePlacementSets: placementSets,
  } = useImageExperienceAdPreviewModel(isMMAV2Enabled ? adPreviewConfigMMAV2 : adPreviewConfig);

  useEffect(() => {
    // transform imageList to 2-dimensional array, the 1st dimension is image,
    // and the 2nd dimension is placement
    const finalImageList = _.map(imageList, image => ([image]));
    onUpdateImageExperienceImageList(finalImageList);
  }, [imageList, onUpdateImageExperienceImageList]);

  const curPlacementList = useMemo(() => {
    const { placementList } = _.first(placementSets) || {};
    // each placement has multiple images, and for this case,
    // make each image in a placement as a separated placement
    const finalPlacementList = [];
    _.forEach(placementList, ({ images, ...rest }) => {
      _.forEach(images, (image) => {
        finalPlacementList.push({ ...rest, ...image });
      });
    });
    return finalPlacementList;
  }, [placementSets]);

  const onRenderPlacement = useCallback((placement, AdPlacementComponent, idx) => {
    const {
      LongHeadline, Headline, Text, BusinessName,
    } = ads[idx] || {};
    return (
      <div className="new-responsive-ad-preview-container" key={idx}>
        <AdPlacementComponent
          placementData={placement}
          longHeadline={LongHeadline}
          shortHeadline={Headline}
          description={Text}
          businessName={BusinessName}
          finalUrl={url}
          i18n={i18n}
        />
      </div>
    );
  }, [ads, i18n, url]);

  return (
    <AdPreviewCarouselLayout
      activeIndex={activeIndex}
      setActiveIndex={setActiveIndex}
      placementList={curPlacementList}
      onRenderPlacement={onRenderPlacement}
      i18n={i18n}
    />
  );
};
